import { useState } from 'react';
import { Modal, Button, SvgIcon } from '@/components';
import Message from 'rc-message';
import './GAUploadModal.less';

export interface GAUploadProps {
  visible: boolean;
  closeLabel: string;
  onClose?: () => void;
}
export function GAUploadModal(
  props: GAUploadProps & React.HTMLAttributes<HTMLDivElement>,
) {
  const { visible, onClose, closeLabel } = props;

  return (
    <Modal visible={visible} className="GA_upload_modal">
      <SvgIcon
        className="cursor"
        style={{ fill: '#0476EB' }}
        name="error"
        width="145"
        height="145"
      />
      <p className="title">未获取</p>
      <p className="desc">
        未成功获取到APP中的MIUI小部件信息，
        请前往应用商店，上传带有MIUI小部件的APP
      </p>
      <Button
        className="dbi w100"
        type="primary"
        href={'https://dev.mi.com/distribute'}
      >
        应用商店
      </Button>
      <Button
        className="mt20 dbi w100"
        onClick={() => {
          onClose && onClose();
        }}
      >
        返回
      </Button>
    </Modal>
  );
}
